module.exports = __webpack_public_path__ + "static/nameplate-71e4ddb81f000c3c81a759daa08a251e.png";